var codeBlocks = document.querySelectorAll("pre code");
codeBlocks.forEach(function (block) {
    block.className.split(" ").forEach(function (className) {
        if (!className.startsWith("data:")) {
            return;
        }
        var data = className.substring(5).split("=");
        var attr = data[0];
        var value = data[1];
        if (!attr || !value) {
            console.warn("Invalid data attribute", data);
            return;
        }
        var parent = block.parentElement;
        if (!parent || parent.tagName.toLowerCase() !== "pre") {
            return;
        }
        parent.setAttribute("data-".concat(attr), value);
    });
});
